export default __webpack_public_path__ + "static/4_15-b47f4ff3ba01d34352015ce62ce9e59e.png";